import { render, staticRenderFns } from "./VJournals.vue?vue&type=template&id=7ab8123b&"
import script from "./VJournals.vue?vue&type=script&lang=js&"
export * from "./VJournals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports